/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim4DiagMaxIcon16Light } from './ArrowDim4DiagMaxIcon16Light';
import { ArrowDim4DiagMaxIcon16Regular } from './ArrowDim4DiagMaxIcon16Regular';
import { ArrowDim4DiagMaxIcon16Solid } from './ArrowDim4DiagMaxIcon16Solid';
import { ArrowDim4DiagMaxIcon20Light } from './ArrowDim4DiagMaxIcon20Light';
import { ArrowDim4DiagMaxIcon20Regular } from './ArrowDim4DiagMaxIcon20Regular';
import { ArrowDim4DiagMaxIcon20Solid } from './ArrowDim4DiagMaxIcon20Solid';
import { ArrowDim4DiagMaxIcon24Regular } from './ArrowDim4DiagMaxIcon24Regular';
import { ArrowDim4DiagMaxIcon24Solid } from './ArrowDim4DiagMaxIcon24Solid';
import { ArrowDim4DiagMaxIcon32Regular } from './ArrowDim4DiagMaxIcon32Regular';
import { ArrowDim4DiagMaxIcon64Regular } from './ArrowDim4DiagMaxIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim4DiagMaxIcon16Light,
        regular: ArrowDim4DiagMaxIcon16Regular,
        solid: ArrowDim4DiagMaxIcon16Solid,
    },
    20: {
        light: ArrowDim4DiagMaxIcon20Light,
        regular: ArrowDim4DiagMaxIcon20Regular,
        solid: ArrowDim4DiagMaxIcon20Solid,
    },
    24: {
        regular: ArrowDim4DiagMaxIcon24Regular,
        solid: ArrowDim4DiagMaxIcon24Solid,
    },
    32: {
        regular: ArrowDim4DiagMaxIcon32Regular,
    },
    64: {
        regular: ArrowDim4DiagMaxIcon64Regular,
    },
};
export var ArrowDim4DiagMaxIcon = forwardRef('ArrowDim4DiagMaxIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
